import { endWebRTCSession } from '@/weon/web-rtc/WeonWebRTC.js';
import { unsubscribeWebSocketStompAndDisconnect } from '@/weon/message-broker/Client';
import { notify } from '@/shared/utils/browser-notify';
import router from '@/router';
import store from '@/store';

const disconnect = async () => {
  await endWebRTCSession();
  unsubscribeWebSocketStompAndDisconnect();
  store.dispatch('resetState');
  indexedDB.deleteDatabase('localforage');
  notify({
    title: 'Sessão encerrada, token perdido',
    body: 'Faça login novamente para continuar os seus atendimentos',
  });
  router.push({ path: '/login' });

  return;
};

export default async (config) => {
  const { token } = localStorage;
  const { agentId } = store.state.attendance.Attendance || {};
  if (
    !token &&
    !router.currentRoute.name.toLocaleLowerCase() !== 'login' &&
    router.currentRoute.name.toLocaleLowerCase() !== 'resetpassword' &&
    agentId
  ) {
    await disconnect();
  }

  if (token) {
    config.headers.Authorization = token;
  }
  return config;
};
